<!-- 合同信息查看 -->
<template>
  <div class="constract-page">
    <h3>合同备案情况查询</h3>
    <div class="tips">
      温馨提示:
      根据相关法律规定，商品房预售经预购方与预售方签订预售合同后，需经住建管理部门办理登记备案手续并进行公示，以维护双方的合法权益:未经登记备案所造成的法律后果由双方自行负担。
    </div>
    <el-descriptions class="margin-top" title="合同信息" :column="1" border>
      <el-descriptions-item label="合同编号">
        {{ htInfo.htbh }}
      </el-descriptions-item>
      <el-descriptions-item label="合同状态">
        <div
          :class="{
            yba: htInfo.htzt === '已备案',
            ycx: htInfo.htzt === '已撤销',
          }"
        >
          {{ htInfo.htzt }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="签订时间">
        {{ htInfo.rwsj }}
      </el-descriptions-item>
      <el-descriptions-item label="入网时间">
        {{ htInfo.qrsj }}
      </el-descriptions-item>
      <el-descriptions-item label="备案时间">
        {{ htInfo.basj }}
      </el-descriptions-item>
      <el-descriptions-item label="合同单价">
        {{ htInfo.dj }}元
      </el-descriptions-item>
      <el-descriptions-item label="合同总价">
        {{ htInfo.zje }}元
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions class="margin-top" title="房屋信息" :column="1" border>
      <el-descriptions-item label="项目名称">
        {{ htInfo.xmmc }}
      </el-descriptions-item>
      <el-descriptions-item label="房号">{{ htInfo.fh }}</el-descriptions-item>
      <el-descriptions-item label="预售许可证号">
        {{ htInfo.ysxkz }}
      </el-descriptions-item>
      <el-descriptions-item label="房屋用途">
        {{ htInfo.fwyt }}
      </el-descriptions-item>
      <el-descriptions-item label="建筑面积">
        {{ htInfo.jzmj }}m²
      </el-descriptions-item>
      <el-descriptions-item label="套内面积">
        {{ htInfo.tnmj }}m²
      </el-descriptions-item>
      <el-descriptions-item label="分摊面积">
        {{ htInfo.ftmj }}m²
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions class="margin-top" title="出卖人信息" :column="1" border>
      <el-descriptions-item label="出卖人">
        {{ htInfo.qymc }}
      </el-descriptions-item>
      <el-descriptions-item label="注册地址">
        {{ htInfo.zcdz }}
      </el-descriptions-item>
      <el-descriptions-item label="证件号">
        {{ htInfo.yyzz }}
      </el-descriptions-item>
      <el-descriptions-item label="法定代表人">
        {{ htInfo.fddbr }}
      </el-descriptions-item>
      <el-descriptions-item label="联系电话">
        {{ htInfo.lxdh }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions class="margin-top" title="买受人信息" :column="1" border>
      <el-descriptions-item label="买受人">
        {{ htInfo.msrxm }}
      </el-descriptions-item>
      <el-descriptions-item label="证件号">
        <div v-for="zjhm in htInfo.zjhm">{{ zjhm }}</div>
      </el-descriptions-item>
      <el-descriptions-item label="联系地址">
        {{ htInfo.lxdz }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup name="">
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getContractInfoByIdRe } from '@/api/common';

const htInfo = ref({});
const route = useRoute();

onMounted(() => {
  const htid = route.query.htid;
  getContractInfoByIdRe({ htid }).then((res) => {
    htInfo.value = res.data;
    if (htInfo.value.zjhm) {
      htInfo.value.zjhm = htInfo.value.zjhm.split(',');
    }
  });
});
</script>

<style lang="scss">
.constract-page {
  padding: 20px;

  & > .tips {
    text-align: left;
    color: red;
  }
  .el-descriptions {
    margin-top: 20px;
  }
  .el-descriptions__label {
    width: 30%;
    min-width: 30%;
  }
  .el-descriptions__content {
    word-break: break-all;
    .yba {
      color: red;
    }
    .ycx {
      color: gray;
    }
  }
}
</style>
